// extracted by mini-css-extract-plugin
export var filterIncDec = "_3y-0";
export var leftBorder = "_3y-1";
export var rightBorder = "_3y-2";
export var stringInput = "_3y-3";